import BootstrapTooltip from "@/react/bootstrap/components/BootstrapTooltip";

type Props = {
    errors: string[];
}

export default function ContentErrors(props: Props) {
    if (0 === props.errors.length) {
        return null;
    }

    const count = props.errors.length;

    return (
        <BootstrapTooltip title={`${count} erreur${count > 1 ? "s" : ""}`}>
            <span className="bi-exclamation-triangle-fill text-danger fw-bolder" />
        </BootstrapTooltip>
    );
}
